import axios from "axios";
import axiosInstance from "../../_utils/axiosConfig";
export const taxe = async()=>{
  try{
        const response = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/api/taxe`);
        return response.data;
  }catch(error){
    console.log("Erreur lors de recuperation ",error)
  }
}